<template>
  <div id="companyCss">
    <BaseBread style="margin-left: 5vh;">
      <BaseBreadItem to="/">首页</BaseBreadItem>
      <BaseBreadItem>企业荣誉</BaseBreadItem>
    </BaseBread>
    <div style="background-color: #fff">
      <!--  企业荣誉   -->
      <HonorCompanyHonor/>
      <!--  知识产权   -->
      <HonorCompanyProperty/>
    </div>
  </div>
</template>

<script setup>
// 页面元数据
useHead({
  title: '企业荣誉 - 杭州建航物流科技',
  meta: [
    { name: 'description', content: '杭州建航物流科技有限公司企业荣誉与知识产权展示' }
  ]
})
</script>

<style scoped lang="less">
#companyCss {
  background-color: #FFF;
}
</style>
